import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        url: "http://sota.media",
        socialImage: "",
        links: {
            main: {
                name: '$menu.main.name',
                url: '/'
            },
            projects: {
                name: '$menu.projects.name',
                url: '/projects',
                sublinks: []
            },
            blog: {
                name: '$menu.blog.name',
                url: '/blog',
                sublinks: []
            },
            studio: {
                name: '$menu.studio.name',
                url: '/studio',
                sublinks: [
                    { name: '$menu.studio.submenu.about', url: '/studio' },
                    { name: '$menu.studio.submenu.services', url: '/studio#services' },
                    { name: '$menu.studio.submenu.approach', url: '/studio#approach' },
                    { name: '$menu.studio.submenu.team', url: '/studio#team' }
                ]
            },
            contacts: {
                name: '$menu.contacts.name',
                url: '/contacts',
                sublinks: [
                    { name: '$menu.contacts.submenu.touch', url: '/contacts#touch' },
                    { name: '$menu.contacts.submenu.location', url: '/contacts#location' },
                    { name: '$menu.contacts.submenu.collaboration', url: '/contacts#collaboration' }
                ]
            },
            follow: {
                name: '$menu.follow.name',
                blank: true,
                sublinks: []
            }
        },
        contacts: {
        },
        developer: [
            {
                name: "Relocus",
                caption: "$captions.development",
                link: "http://relocus.ru"
            },
            {
                name: "Maga Alkhasov",
                caption: "$captions.design",
                link: "http://maga.ws"
            }
            
        ],
        category: null
    },
    mutations: {
        setCategories (state, obj) {
            for(var i=0; i<obj.categories.length; i++)
                obj.categories[i]['url'] = "/" + obj.type + "?category=" + obj.categories[i].id;
            state.links[obj.type].sublinks = obj.categories;
        },
        setContacts (state, contacts) {
            state.contacts = contacts;
            state.links.follow.sublinks = contacts.social;
        },
        setSocialImage (state, imageUrl) {
            state.socialImage = state.url + imageUrl;
        },
        setCategory (state, category) {
            state.category = category
        },
        clearCategory (state) {
            state.category = null
        }
    }
})


// WEBPACK FOOTER //
// ./src/store.js